module.exports = __webpack_public_path__ + "static/media/search-active-new.7ab88cd6.svg";